(function () {
  if (window.__bwxGift) return; window.__bwxGift = true;

  function inner(html, sel) {
    var d = new DOMParser().parseFromString(html || '', 'text/html');
    var el = d.querySelector(sel || '.shopify-section');
    return el ? el.innerHTML : null;
  }
  function msg(form, text, ok) {
    var m = form.querySelector('.bwxg-add__msg'); if (!m) return;
    m.textContent = text || ''; m.hidden = !text; m.classList.toggle('is-ok', !!ok);
  }
  function txt(form, key) {
    var f = form.closest('[data-bwxg-t-err]') || form;
    return f.getAttribute(key) || '';
  }

  /* AJAX add to cart, then refresh + open the theme's cart drawer (same flow as the theme's product form) */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('form[data-bwxg-add]'); if (!form) return;
    if (!window.fetch || !window.FormData) return; /* plain form post */
    e.preventDefault();
    var btn = form.querySelector('button[type="submit"]'); if (!btn || btn.disabled) return;
    var drawer = document.getElementById('cart-drawer');
    var fd = new FormData(form);
    if (drawer) { fd.append('sections', 'cart-drawer,cart-icon-bubble'); fd.append('sections_url', window.location.pathname); }
    btn.disabled = true; btn.classList.add('is-loading'); msg(form, '');
    var url = (window.routes && window.routes.cart_add_url) || '/cart/add';
    fetch(url, { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }, body: fd })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) { msg(form, res.description || res.message || txt(form, 'data-bwxg-t-err')); return; }
        if (!drawer) { window.location = (window.routes && window.routes.cart_url) || '/cart'; return; }
        var s = res.sections || {};
        var d = s['cart-drawer'] && inner(s['cart-drawer'], '#cart-drawer');
        if (d !== null && d !== undefined) { drawer.innerHTML = d; drawer.classList.remove('is-empty'); }
        var bubble = document.getElementById('cart-icon-bubble');
        var b = s['cart-icon-bubble'] && inner(s['cart-icon-bubble']);
        if (bubble && b) bubble.innerHTML = b;
        if (window.WhatSub && window.WhatSub.dispatch) {
          window.WhatSub.dispatch('ADD_TO_CART');
        } else {
          drawer.classList.add('animate', 'active'); document.body.classList.add('no-scroll');
        }
        msg(form, txt(form, 'data-bwxg-t-added'), true);
        setTimeout(function () { msg(form, ''); }, 4000);
      })
      .catch(function () { msg(form, txt(form, 'data-bwxg-t-err')); })
      .then(function () { btn.disabled = false; btn.classList.remove('is-loading'); });
  });

  /* product page: switch amount in place */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-bwxg-amt-btn]'); if (!a) return;
    var root = a.closest('[data-bwxg-pdp]'); if (!root) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return;
    e.preventDefault();
    root.querySelectorAll('[data-bwxg-amt-btn]').forEach(function (x) {
      var on = x === a; x.classList.toggle('is-on', on);
      if (on) x.setAttribute('aria-current', 'true'); else x.removeAttribute('aria-current');
    });
    var amt = a.getAttribute('data-amt');
    root.querySelectorAll('[data-bwxg-amt]').forEach(function (x) { x.textContent = amt; });
    var sel = root.querySelector('[data-bwxg-sel]'); if (sel) sel.textContent = amt;
    var im = root.querySelector('[data-bwxg-img]'), src = a.getAttribute('data-img');
    if (im && src) { im.removeAttribute('srcset'); im.src = src; }
    var pr = root.querySelector('[data-bwxg-price]'); if (pr) pr.textContent = a.getAttribute('data-price');
    var vid = root.querySelector('[data-bwxg-vid]'); if (vid) vid.value = a.getAttribute('data-id');
    var btn = root.querySelector('form[data-bwxg-add] button[type="submit"]');
    if (btn) {
      var ok = a.getAttribute('data-avail') === 'true';
      btn.disabled = !ok;
      btn.querySelector('span').textContent = btn.getAttribute(ok ? 'data-t-add' : 'data-t-off');
    }
    var f = root.querySelector('form[data-bwxg-add]'); if (f) msg(f, '');
    try { history.replaceState(null, '', a.getAttribute('href')); } catch (x) {}
  });
})();
